import { isNotNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { ATTACHED_TO_PROP } from '../../common/config/common-prop-names';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { attentionNodeTemplate } from '../attention-node';
import { attentionOverrideDraggingTool } from '../utils/attention-dragging-tool';
import { ATTENTION_LAYER_NAME } from './../config/part-names';
import { attentionOverrideLayout } from './../utils/attention-layout';
import { attentionOverrideResizingTool } from './../utils/attention-resizing-tool';

export const setupAttentionNode = (diagram: go.Diagram, categoryName: string) => {
  setupAttentionLayer(diagram);
  registerNodeTemplate(diagram, categoryName, attentionNodeTemplate());
  attentionOverrideLayout(diagram, categoryName);
  attentionOverrideDraggingTool(diagram, categoryName);
  attentionOverrideResizingTool(diagram, categoryName);

  return registerDiagramListeners(diagram, categoryName);
};

const registerDiagramListeners = (diagram: go.Diagram, categoryName: string) => {
  const eventHandler = toggleAttentionNodeVisibility(categoryName);

  diagram.addDiagramListener('SubGraphCollapsed', eventHandler);
  diagram.addDiagramListener('SubGraphExpanded', eventHandler);

  return () => {
    diagram.removeDiagramListener('SubGraphCollapsed', eventHandler);
    diagram.removeDiagramListener('SubGraphExpanded', eventHandler);
  };
};

const toggleAttentionNodeVisibility =
  (categoryName: string) =>
  ({ subject, diagram }: go.DiagramEvent) => {
    if (!(subject instanceof go.List) || !subject.all((s) => s instanceof go.Group)) {
      return;
    }

    const attentionNodes = diagram.nodes.filter(
      (n) => n.category === categoryName && isNotNullish(n.data[ATTACHED_TO_PROP]),
    );
    subject.each((group: go.Group) => {
      const attentionsInGroup = attentionNodes.filter((node) =>
        group.memberParts.any((part) => part.key === node.data[ATTACHED_TO_PROP]),
      );
      attentionsInGroup.each((attention) => (attention.visible = group.isSubGraphExpanded));
    });
  };

const setupAttentionLayer = (diagram: go.Diagram) => {
  const $ = go.GraphObject.make;
  const attentionLayer = $(go.Layer, { name: ATTENTION_LAYER_NAME });
  const adornmentLayer = diagram.findLayer('Adornment');
  if (!adornmentLayer) {
    return;
  }

  diagram.addLayerBefore(attentionLayer, adornmentLayer);
};
